export const ERRORS = {
  couldNotUpdateProjects: 'Could not update projects',
}
